import type from './types';

const INITIAL_STATE = {
  list: [],
  loading: false,
  ranking: null,
  rankingLoading: false,
  error: false,
  rankingError: false,
};

/**
 * @param {Object} state - Default application state
 * @param {Object} action - Action from action creator
 * @returns {Object} New state
 */
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case type.LIST_FETCHED:
      return {
        ...state,
        list: action.payload.data,
        loading: false,
        error: false,
      };
    case type.LIST_LOAD:
      return { ...state, loading: action.payload };
    case type.RANKING_FETCHED:
      return {
        ...state,
        ranking: action.payload.data,
        rankingLoading: false,
        rankingError: false,
      };
    case type.RANKING_LOAD:
      return { ...state, rankingLoading: action.payload };
    case type.LIST_ERROR:
      return { ...state, loading: false, error: true };
    case type.RANKING_ERROR:
      return { ...state, rankingLoading: false, rankingError: true };
    default:
      return state;
  }
};
